import { Component, OnInit, inject } from "@angular/core";
import { setTheme } from "ngx-bootstrap/utils";
import { MessageService } from "primeng/api";
import { environment } from "../environments/environment";
import { ClientService } from "./client.service";
import { FreshdeskWebchat } from './freshdesk-webchat.service';
import { VersionCheckService } from "./version-check.service";
import { PosthogService } from "./shared/services/postHog.service";
import { MainComponent } from "./core/components/main/main.component";
import { ToastModule } from "primeng/toast";
import { ButtonModule } from "primeng/button";


@Component( {
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    imports: [MainComponent, ToastModule, ButtonModule],
} )
export class AppComponent implements OnInit {
  messageService = inject( MessageService );
  private readonly versionCheckService = inject( VersionCheckService );
  private clientService = inject( ClientService );
  private readonly freshdeskWebchatService = inject( FreshdeskWebchat );
  private readonly posthogService = inject( PosthogService );

  public clientInfo: any;
  public titleIcon = "";
  public title = "";
  constructor () {
    setTheme( "bs4" );

    // Enforce light theme immediately
    this.enforceLightTheme();

    console.log( "Remove error and loader classes from styles.scss" );
  }

  private enforceLightTheme () {
    // Set color scheme and data-theme attribute
    document.documentElement.style.colorScheme = "light";
    document.documentElement.setAttribute( "data-theme", "light" );

    // Remove any dark classes
    document.documentElement.classList.remove( "dark" );
    document.body?.classList.remove( "dark" );

    // Prevent dark mode from being applied via MutationObserver
    const observer = new MutationObserver( ( mutations ) => {
      mutations.forEach( ( mutation ) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          const target = mutation.target as HTMLElement;
          if ( target.classList.contains( "dark" ) ) {
            target.classList.remove( "dark" );
          }
        }
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "data-theme"
        ) {
          const target = mutation.target as HTMLElement;
          if ( target.getAttribute( "data-theme" ) !== "light" ) {
            target.setAttribute( "data-theme", "light" );
          }
        }
        if ( mutation.type === "childList" ) {
          mutation.addedNodes.forEach( ( node ) => {
            if ( node.nodeType === Node.ELEMENT_NODE ) {
              const element = node as HTMLElement;
              if ( element.classList?.contains( "dark" ) ) {
                element.classList.remove( "dark" );
              }
            }
          } );
        }
      } );
    } );

    observer.observe( document.documentElement, {
      attributes: true,
      attributeFilter: ["class", "data-theme"],
      childList: true,
      subtree: true,
    } );
  }

  async ngOnInit () {
    // Ensure light theme is still enforced
    this.enforceLightTheme();

    this.clientInfo = await this.clientService.getClientByUrl();
    this.titleIcon = this.clientInfo?.titleIcon;
    this.title = this.clientInfo?.title;
    let link = document.querySelector( "link[rel~='icon']" );
    if ( !link ) {
      link = document.createElement( "link" );
      link["rel"] = "icon";
      document.getElementsByTagName( "head" )[0].appendChild( link );
    }
    document.title = this.title;
    link["href"] = this.titleIcon;
    this.versionCheckService.initVersionCheck();
		// Initialize Freshdesk Webchat Service
		this.freshdeskWebchatService.init();
    // this.initTracingThirdParty(); we turn off this to check if the slowness if exist from this posthog
  }

  initTracingThirdParty () {
    this.posthogService.init( environment.POSTHOG_KEY, {
      api_host: environment.POSTHOG_HOST,
      capture_pageview: false, // Tracks initial page views
      capture_pageleave: false, // Tracks when users leave pages
      autocapture: false,
      disable_session_recording: true,
      session_recording: {
        maskAllInputs: false,
      },
      // History tracking:
      enable_recording_console_log: false, // Captures console.log (including errors)
      // Advanced config for your use cases:
      persistence: "localStorage+cookie", // Better history tracking
      property_blacklist: ["$referrer"], // Cleaner history data
      sanitize_properties: ( properties ) => {
        // Clean sensitive data
        delete properties["$current_url"]; // Optional if you want full URLs
        return properties;
      },
    } );
  }
}
